exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".dialog-tag {\n  min-width: 300px;\n  min-height: 150px;\n  overflow: auto; }\n  .dialog-tag .color-picker {\n    width: 100% !important; }\n\n@media only screen and (max-width: 600px) {\n  .dialog-tag {\n    min-width: auto;\n    max-height: 300px; }\n    .dialog-tag .color-picker {\n      width: calc(100% - 48px); } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/tags/EditAdd/index.scss
// module id = 1466
// module chunks = 0